import React, { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { login,AsterConfig,LoginUserinfo } from '../redux/apicalling/dispatchfunction.js';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import "../assets/css/loginpage.css"
import { useNavigate } from 'react-router-dom';
import loginimg from '../assets/images/login2.png'
import dooctilogo from '../assets/images/logo.png'
import skyfalllogo from "../assets/images/SKyfalllogo.png"
import gtawklogo from "../assets/images/gtawk.png"
import { toast } from 'react-toastify';

import Comtemplete from './comtemplete.js';
function Login() {
  
  const navigate=useNavigate()
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
   const [logo,setLogo] = useState()
  const dispatch = useDispatch();
  const loginlocal = localStorage.getItem('login'); // Access the token from localStorage
  useEffect(() => {
   
    //Runs only on the first render
    if (loginlocal == "true") {
    // window.location.href = `/homepage`;
    navigate('/homepage')
    }else{
      
    }
    
  }, []);

     useEffect(() => {
          var interval = null;
          console.log('=====>', window.location.hostname);
          const baseURL = window.location.hostname;
          // const baseURL = "crm-dev.doocti.com/";
          if (baseURL.includes('doocti.com')) {
              setLogo(dooctilogo)
  
          } else if (baseURL.includes('gtawk.com')) {
              setLogo(gtawklogo)
          } else if (baseURL.includes('skyfalltech.in')) {
              setLogo(skyfalllogo)
          } else if (baseURL.includes('localhost')) {
              // setLogo(dooctilogo)
              setLogo(skyfalllogo)
          } else {
              setLogo(dooctilogo)
          }
        
      }, []);
    
  useEffect(() => {
   
   window.addEventListener('message', handleMessage);
    return () => {

       

        window.removeEventListener('message', handleMessage);

    };


}, []);

const handleMessage = async (event) => {

try {
 

  const stationnumber = event.data.user_number
  if (stationnumber !== null && stationnumber !== undefined) {
    localStorage.setItem('crmuserinfo',JSON.stringify(event.data))
    localStorage.setItem('station', stationnumber)  
  }
  

} catch (error) {
  return error
}


}


  const handleLogin = () => {
    setIsLoggingIn(true);
    dispatch(login(username, password)).then((additionalData) => {
    if (additionalData.status === 200) {
       
        const storedApinfo = localStorage.getItem('apinfo'); 
    const apiinfo = JSON.parse(storedApinfo);
     const doocti_tenent =apiinfo.tenant_code;
     setIsLoggingIn(false);
     
    dispatch(AsterConfig(username,doocti_tenent))
    .then((response) => {
      if (response.status === 200) {
        
      //  window.location.href='/queuepage';   
        let data = JSON.stringify(response.data)
        localStorage.setItem("config", data)
        let config_user = response.data.projects[0].userInfo[0].user_email
        localStorage.setItem('username',config_user)
        navigate('/queuepage')  
       
      }
      
    })
    .catch((err) => {
      
     return err
    });
    
   }
    
  })
  .catch((error) => {
    // Handle login error
    setIsLoggingIn(false);
    toast.error('Login Failed !! Check Credential!')
    console.error('Login failed:', error);
  });
       };
       const override = css`
       display: block;
       margin: 0 auto;
       border-color: red;
     `;
 
       return (
   
    <div>
   
   <div className='login-container'>
   <div className='login-side-img'>
    <img class ="login-side-inline-img" src={loginimg} ></img>     
   
   </div>
   
   <img className='login-logo-image' src={logo}></img>
   
   <div className="login-box">
    
    <form>
      <div className="form-group">
        <div className='login-title' >Login</div>
        <label htmlFor="username">UserEmail</label>
        <input className='logininput' type="text" placeholder="abcd@doocti.com" value={username} onChange={(e) => setUsername(e.target.value)} />

      </div>
      <div className="form-group">
        <label htmlFor="password">Password</label>
        <input className='logininput' type="password" placeholder="1234" value={password} 
        onChange={(e) => setPassword(e.target.value)} />

     
      </div>

    
    <button type="button" className="login-button" onClick={handleLogin} disabled={isLoggingIn}>
            {isLoggingIn ? <ClipLoader color={'#ffffff'} loading={isLoggingIn} css={override} size={20} /> : 'Login'}
          </button>
                
    </form>
  
      
  
  </div>
    


    </div>
   
 
  </div>    

   );

}

export default Login;
